module.exports = __webpack_public_path__ + "img/intense_original.e07e378.jpg";